<style lang="less">
@import "../../../../styles/common-table-list.less";
</style>
<template>
    <div>  
        <Row class="table-style-size">
            <i-col span="6">时间</i-col>
            <i-col span="5">金额</i-col>
            <i-col span="5">操作</i-col>
            <i-col span="8">备注</i-col>
        </Row> 
        <div v-if="records.length>0">
            <div style="height:528px">
                <Row class="table-style-size table-style-body" style="height:65px" v-for="(item,index) in records" :key="index">        
                    <i-col span="6">{{item.createDate}}</i-col>      
                    <i-col span="5">-{{item.drawAmount}}</i-col>    
                    <i-col span="5">提现</i-col>
                    <i-col span="8" class="notwrap">{{item.remarks}}</i-col>
                </Row>         
            </div>           
            <div class="commont-page" style="margin-top:30px">
                <Page :page-size="pageSize"  @on-change="changepage" :total="total" size="small" show-total show-elevator class="page-size-style"></Page><span class="page-total-span">/&nbsp;{{pages}}页</span>
            </div>
        </div>
        <div class="empty-box" v-if="records.length<=0&&flag">
            <img src="@/assets/empty.png" class="empty-img" alt='版权登记'/>
            <p>表单暂无数据哦～</p>
        </div>
        
    </div>
    
</template>

<script>
import { _getInviteByPage } from "@/api/wallet.js";
import Cookies from "js-cookie";
export default {
    metaInfo: {
        title: '提现|版权服务专家|版权家',
        meta: [{                 // set meta
            name: 'keyWords',
            content: '版权服务,版权百科,版权,版权家,版权存证,版权交易,版权监测,版权维权,版权登记,版权公证,版权签名,数字版权,版全家,版权侵权取证,版权法律维权服务,区块链版权登记,区块链版权确权,区块链版权存证,区块链版权'
        },{
            name: 'Description',
            content: '提现,版权家,人人都是创作者，人人都是版权人。版权家秉持让版权实现更大价值的使命，使用创新的版权区块链和版权签名技术，为版权人提供极致的版权存证、版权交易、版权监测、版权维权服务体验。'
        }]
    },
    name:'invitePage',
    data(){
        return{
            total:0,
            pages:0,
            pageNumber:1,
            pageSize:8,
            records:[],
            flag:false
        }
    },
    methods: {
        findByPage(){
            let userInfo = Cookies.get("userInfo")?JSON.parse(Cookies.get("userInfo")):'';
            const data={
                pageNumber:this.pageNumber,
                pageSize:this.pageSize,
                sort:'create_date',
                order:'desc',
                registerId:userInfo && userInfo.id?userInfo.id:'',
                drawWay:'alipay',
                drawOrigin:'commission'
            }
            _getInviteByPage(data).then(res => {
                if(res.code==200){
                    this.total=Number(res.result.total);
                    this.pages=res.result.pages;
                    this.records=res.result.records;
                    this.flag=true;
                }           
                              
            });
        },
        //分页
        changepage(index){
            this.pageNumber = index;
            this.findByPage()
        },
    },
    mounted() {
        this.findByPage()
    },
}
</script>